import axiosInstance from './AxiosInstance';

const fetchVendors = async (searchParams = {}, page , pageSize , sortBy = "", order = "asc") => {
  const queryObj = { ...searchParams, page, pageSize };
  console.log("Query Object:", queryObj);
  if (sortBy) {
    queryObj.sortBy = sortBy;
    queryObj.order = order;
  }

  try {
    const response = await axiosInstance.get('/vendors', {
      params: queryObj,
    });
    console.log("Response:", response.data);
    return response.data;
  } catch (error) {
    console.error("Failed to fetch vendors:", error);
    throw error;
  }
};

const updateVendor = async (vendorId, vendorData) => {
  try {
    const fieldMapping = {
      supplierSiteId: vendorData.supplier_site_id,
      deptNumber: vendorData.dept_code,
      vendorName: vendorData.vendor_name,
      commodityCode: vendorData.commodity_code_id,
      fobTerms: vendorData.fob_terms,
      chain: vendorData.chain,
      area: vendorData.area,
      brandId: vendorData.brand_id,
      brandDesc: vendorData.brand_desc,
    };

    const response = await axiosInstance.put(`/vendors/${vendorId}`, fieldMapping);
    return response.data;
  } catch (error) {
    console.error("Error updating vendor:", error);
    throw error;
  }
};

const fetchCommodityCodes = async () => {
  try {
    const response = await axiosInstance.get('/commodityCode', {
      params: { pageSize: 100, sortBy: "commodity_code" },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching commodity codes:", error);
    throw error;
  }
};

const copyVendorRow = async (payload) => {
  const copyVendor = {
    supplier_site_id: payload.supplier_site_id,
    dept_number: payload.dept_code,
    vendor_name: payload.vendor_name,
    address: payload.address,
    address_cont: payload.address_cont,
    city: payload.city,
    zip: payload.zip,
    commodity_code_id: payload.commodity_code_id,
    fob_terms: payload.fob_terms,
    chain: payload.chain,
    area: payload.area,
    brand_id: payload.brand_id || 0 ,
    brand_desc: payload.brand_desc || "null",
  };
   console.log("Copy Vendor:", copyVendor);
  try {
    const response = await axiosInstance.post('/vendors', copyVendor);
    return response.data;
  } catch (error) {
    console.error("Error copying row data:", error);
    throw error;
  }
};

export { 
  fetchVendors, 
  updateVendor, 
  fetchCommodityCodes, 
  copyVendorRow 
};